import apiClient from '../api-client';
import type {
  SpecialDateOperatingHours,
  CreateSpecialDateOperatingHoursRequest,
  UpdateSpecialDateOperatingHoursRequest,
  PaginatedResponse,
  PaginationParams,
} from '@geely/shared/types';

export interface SpecialDateOperatingHoursQueryParams {
  storeId: string;
  date?: string;
}

export const specialDateOperatingHoursApi = {
  list: (params: SpecialDateOperatingHoursQueryParams) =>
    apiClient.get<SpecialDateOperatingHours[]>('/special-date-operating-hours', { params }),

  listPaginated: (params: SpecialDateOperatingHoursQueryParams & PaginationParams) =>
    apiClient.get<PaginatedResponse<SpecialDateOperatingHours>>('/special-date-operating-hours', { params }),

  create: (data: CreateSpecialDateOperatingHoursRequest) =>
    apiClient.post<SpecialDateOperatingHours>('/special-date-operating-hours', data),

  update: (id: string, data: UpdateSpecialDateOperatingHoursRequest) =>
    apiClient.patch<SpecialDateOperatingHours>(`/special-date-operating-hours/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/special-date-operating-hours/${id}`),
};
